<div class="playbook-template-card">
  <div class="playbook-template-card-header">
    <div class="playbook-template-card-header-text">
      {{ card.titleLabel | labelsProvider }}
    </div>
    <img class="playbook-template-card-header-img" [src]="card.logoPath" />
  </div>
  <div class="playbook-template-card-description">
    {{ card.descriptionLabel | labelsProvider }}
  </div>
  <div
    class="playbook-template-card-action"
    [matTooltip]="tooltip"
    matTooltipPosition="below"
    matTooltipClass="tooltip-container"
  >
    <div
      [ngClass]="{
        'playbook-template-card-action-link-disabled': !hasPermisions,
        'playbook-template-card-action-link-active': hasPermisions,
      }"
      class="playbook-template-card-action-link"
      (click)="actionClicked()"
    >
      {{ card.actionLabel | labelsProvider }}
    </div>
  </div>
</div>
